import { render, staticRenderFns } from "./IconFilter.vue?vue&type=template&id=27d23da6&"
import script from "./IconFilter.vue?vue&type=script&lang=js&"
export * from "./IconFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports